<template>
<vue-scroll :settings="{wheelPropagation:true}" class="betslip-l" v-if="betslip != null">
    <TicketsCreatedList
    v-if="placedTicketsPopupDisplayed"
    :tickets="createdTickets"
    @close="placedTicketsPopupDisplayed = false"
    @getticket="getTicket" />
  <!--div class="scroll-betslip"--><div class="betslip-container">
    <div class="verify-ticket" v-if="!isMobile">
        <div class="input-box">
            <input class="input-text" ref_testcafe="check_ticket_input" v-model="ticketCode" @keyup.enter="getTicket" v-bind:placeholder="$t('VERIFYTICKET')" type="text">
        </div>
        <a class="button button-input" ref_testcafe="check_ticket_button" v-on:click="getTicket"><!--{{$t('VERIFY')}}--><i class="iconset icon-checkticket"></i></a>
    </div>
    <div class="current-balance" v-if="showBalance && !isMobile">
        <div class="balance">
            <p>{{$t('CURRENTBALLANCE')}}:</p>
            <span class="balance-value" ref_testcafe="virtual_terminal_balance">{{playerdata.money.balance | formatNum}}
                <span class="light-text">{{ $getCurrencyAbbrv(playerdata.money.currency) }}</span>
            </span>
        </div>
        <img src="../../../assets/img/icon-balance.svg" class="icon-balance">
    </div>
    <router-link v-if="showLottoResultsButton && resultsRoute != null" class="button button-results-lotto full" :to="{ path: resultsRoute }">{{$t('RESULTS')}}</router-link>
    <div class="betslip">
        <!-- div class="betting-disabled"><img src="../../../assets/img/locked.svg"></div --> <!-- TODO add logic for blocked betting -->
      <div class="bslip-info" v-if="isMobile" v-on:click="betslipOpen = !betslipOpen;">
          <div class="bslip-info-left">
              <div class="games-counter">
                <i class="iconset icon-betslip games-counter-icon"></i>
                  <span class="games-counter-num">{{betslipItems.length}}</span>
              </div>
              <div class="games-info">
                  <!--div v-if="betslipType == 'lotto' && betslipItems.length" class="bslipbottom-details bslipbottom-lottonumbers">
                    <span>{{$t('SELECTEDNUMBERS')}}</span>
                    <p>{{ selectedNumbers }}</p>
                  </div-->
                  <div v-if="betslipType == 'sport'" class="bslipbottom-details">
                    <span>{{$t('STAKE')}}</span>
                    <p>{{betslip.betStake | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.betStake) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
                  <div class="bslipbottom-details">
                    <span>{{$t('POTENTIALPAYOUT')}}</span>
                    <p>{{betslip.potentialPayout | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialPayout) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
              </div>
          </div>
          <div class="bslip-info-right">
              <!--<span>{{$t('OPENBETSLIP')}}</span>-->
              <!--i class="iconset icon-arrowup"></i-->
              <button class="button button-blue">{{$t('SHOWBETSLIP')}}</button>
          </div>
      </div>

        <template v-if="isMobile">
            <BetslipErrors
            v-if="allTicketErrors.length"
            :errors="allTicketErrors" />
        </template>

        <div class="loading-container betslip-loading" v-if="ticketIsLoading">
            <img src="../../../assets/img/loading.svg">
        </div>
      <div class="bslip-box" v-bind:class="betslipOpen ? 'is-active' : ''">
        <div class="bslip-header">
          <i class="icon-delete iconset delete-games" v-on:click.prevent="clearItems"></i>
            <div class="bslip-header-sport">
              <div v-if="showSimple" class="bslip-header-type" :class="((betsOpen || !isMobile) && betslip.betslipDef == 'simple') ? 'is-selected' : ''" v-on:click="toggleBetslipDef('simple')">
                <p class="bslip-bet-type">{{$t('SIMPLETICKET')}}</p>
              </div>
                <div v-if="showSystem" class="bslip-header-type" :class="((betsOpen || !isMobile) && betslip.betslipDef == 'combination') ? 'is-selected' : ''" v-on:click="toggleBetslipDef('combination')" ref_testcafe="systemTicket">
                <p class="bslip-bet-type">{{$t('SYSTEMTICKET')}}</p>
                </div>

                <div v-if="isMobile" class="bslip-header-type" :class="(!betsOpen) ? 'is-selected' : ''" v-on:click="betsOpen = false;">
                  <p class="bslip-bet-type">{{$t('TICKETLIST')}}</p>
                </div>
            </div>
            <i class="iconset icon-arrowdown close-ticket" v-on:click="betslipOpen = false;"></i>
        </div>
            <div class="bslip-box-items" v-show="!isMobile || (betsOpen && isMobile)" ref_testcafe="pickedMatchesFrontend">
                <div class="bslip-item" v-if="!betslipItems.length">
                    <div class="bslip-teams no-events">
                        <p class="bslip-game-part">{{$t('TICKETEMPTYADDEVENTS')}}</p>
                    </div>
                </div>
                <template v-else-if="isSportTicket">
                    <BetslipItem v-for="(item, i) in ticketItems" :itemIndex="i" :item="item" :key="item.matchId" />
                </template>
                <template v-else-if="betslipType === 'vhorse'">
                    <BetslipItem v-for="(item, i) in ticketItems" :itemIndex="i" :item="item" :key="item.matchId" />
                </template>
                <BetslipLottoItem
                    v-else-if="betslipType === 'lotto'
                    && ticketItems[0]
                    && ticketItems[0].type === 'lotto'"
                    :ticketItems="ticketItems"
                    :tickets="tickets"
                    @deleteticket="deleteTicket"
                />
                <template v-else-if="betslipType === 'lotto_extended'">
                    <ticket-lotto-extended-item v-for="(item, i) in ticketItems" :itemIndex="i" :item="item" :key="item.meta.outcomeId" />
                </template>
                <div class="bslip-system fadeInDown" ref_testcafe="systemCombinationsContainer"
                v-if="betslip.combinations.length > 0 && showCombinations && betslip.betslipDef == 'combination'">
                    <img class="info-icon" src="../../../assets/img/icon-info.svg" v-if="isMobile && showHelp" @click="openHelp(6)">
                    <div class="bsystem-item" v-for="comb in betslip.combinations" :key="comb.id" :class="{'is-selected': (comb.selected == true)}">
                        <label class="label" v-on:click.prevent="toggleCombination(comb)">
                            <input class="input-checkbox full" type="checkbox" :checked="comb.selected">
                            <span class="checkmark"></span>
                            <span class="label-text">{{comb.value | parseStringToTranslatable}}</span>
                        </label>
                    </div>
                </div>

            </div>

        <div class="ticket-bonus-alert fadeInUp" v-if="betslip.hasAchievedBonus">
                <img src="../../../assets/img/icon-bonus-ticket.svg" />
                <p>{{$t('BETSLIPBONUSACHIVED')}}</p>
            </div>

        <div>
            <div v-if="!isMobile || betsOpen">
            <form action="" class="bslip-fixed-stakes">
                <a v-for="(payinValue, index) in predefinedPayinValues"
                :key="index"
                class="button button-grey-first button-bslip-stakes"
                v-on:click="changePredefinedPayin(payinValue)">
                    {{ payinValue }} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                </a>
                <a class="button button-grey-first button-bslip-stakes" v-on:click="mtsMaxStakeAction"
                v-if="globals != null
                && globals.publicConfig != null
                && globals.publicConfig.website != null
                && globals.publicConfig.website.showMtsStakeButton === true
                && betslipType === 'sport'
                && betslipItems.length
                && betslip.betslipOnline === 'online'">
                    {{(mtsMaxStakeValue !== null) ? mtsMaxStakeValue : '?'}}
                </a>
            </form>
            <div class="bslip-stake">
                <div class="input-box">
                    <input class="input-text"
                    v-if="isMobile"
                    type="number"
                    pattern="[0-9.,]*"
                    @input="changeCalcDisplayedBetAmount"
                    :value="formatDisplayedBetAmount"
                    @focus="inputPayinSelectAll"
                    @blur="betAmountInputFocused = false;"
                    @keyup="focusPlaceBet($event)"
                    ref="amountinputmobile">
                    <input ref="inputPayin" class="input-text" v-else type="text" @input="changeCalcDisplayedBetAmount" :value="formatDisplayedBetAmount" @focus="inputPayinSelectAll" @blur="betAmountInputFocused = false;" ref_testcafe="totalStake">
                </div>
                <span class="bslip-stake-text">
                    {{(betslipType === 'lotto' && tickets.length) ? $t('PAYINPERTICKET') : $t('TICKETPAYIN')}}:
                    </span>
                <span class="bslip-stake-currency">{{ $getCurrencyAbbrv(playerdata.money.currency) }}</span>
          </div>
          <div class="bslip-data mbslip-data" v-if="betslipItems.length">
            <div v-if="isMobile">
                <div class="mbslip-payin-info-container">
                    <input type="checkbox" name="collapse" id="mbslippayininfo" style="position: absolute; left: -100vw;">
                    <label for="mbslippayininfo" class="mbslip-payin-info-expand">
                        {{ $t('TICKET_DETAILS') }}
                        <i class="iconset icon-arrowdown"></i>
                    </label>
                    <div class="mbslip-payin-info" style="display: none;">
                        <div class="top">
                            <div class="bslip-data-item" v-if="tickets.length && betslipType === 'lotto'">
                                <p>{{$t('TOTALPAYIN')}}: </p>
                                <div class="bslip-data-value">
                                    <p>{{betslip.payin * tickets.length | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                                    <p class="second-currency">
                                        <template v-if="calculateEurConversion">
                                            ({{getEurValue(betslip.payin * tickets.length) | formatNum}} {{$t('CURRENCYABBRV_EUR')}})
                                        </template>
                                    </p>
                                </div>
                            </div>
                            <div class="bslip-data-item" v-if="betslip.betslipDef == 'simple' && betslipType != 'lotto' && betslipType != 'vhorse'">
                                <p>{{$t('NUMBEROFEVENTS')}}: </p>
                                <p>{{betslipItems.length}}</p>
                            </div>
                            <div class="bslip-data-item" v-if="betslip.betslipDef == 'combination'">
                                <p>{{$t('COMBINATIONNUMBER')}}: </p>
                                <p>{{betslip.numberOfCombinations}}</p>
                            </div>
                            <div class="bslip-data-item" v-if="betslip.betslipDef === 'simple' || betslipType === 'lotto'">
                                <p>{{$t('TOTALODD')}}: </p>
                                <p>{{betslip.totalCoefficient | formatNum(4)}}</p>
                            </div>
                        </div>

                        <div class="middle">
                            <div class="bslip-data-item">
                                <p>{{$t('POTENTIALWIN')}}:</p>
                                <div class="bslip-data-value">
                                    <p>{{betslip.potentialWin | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                                    <p class="second-currency">
                                        <template v-if="calculateEurConversion">
                                            ({{getEurValue(betslip.potentialWin) | formatNum}} {{$t('CURRENCYABBRV_EUR')}})
                                        </template>
                                    </p>
                                </div>
                            </div>
                            <div class="bslip-data-item">
                                <p>{{$t('WINTAX')}}:</p>
                                <div class="bslip-data-value">
                                    <p>{{betslip.payoutTax | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                                    <p class="second-currency">
                                        <template v-if="calculateEurConversion">
                                            ({{getEurValue(betslip.payoutTax) | formatNum}} {{$t('CURRENCYABBRV_EUR')}})
                                        </template>
                                    </p>
                                </div>
                            </div>
                            <div class="bslip-data-item" v-if="betslip.handlingFeePercentage">
                                <p>{{$t('TICKETCDA')}}: </p>
                                <div class="bslip-data-value">
                                    <p>{{betslip.handlingFee | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                                    <p class="second-currency">
                                        <template v-if="calculateEurConversion">
                                            ({{getEurValue(betslip.handlingFee) | formatNum}} {{$t('CURRENCYABBRV_EUR')}})
                                        </template>
                                    </p>
                                </div>
                            </div>
                            </div>
                            <div class="bslip-data-combinations" v-if="betslipType == 'lotto' && Object.keys(betslip.lottoHitBallWins).length">
                                <div class="bslip-data-item" v-for="(win, i) in betslip.lottoHitBallWins" :key="i">
                                <p>{{$t('GUESSEDNUMBERCOUNT', {num: i})}}: </p>
                                <div class="bslip-data-value">
                                    <p class="bslip-ball-hit-amount">{{win.winTaxed | formatNum}} ({{win.win | formatNum}}) {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                                    <p class="second-currency">
                                        <template v-if="calculateEurConversion">
                                            ({{getEurValue(win.winTaxed) | formatNum}} {{$t('CURRENCYABBRV_EUR')}})
                                        </template>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bottom">
                  <div class="bslip-data-item big light">
                      <span>{{$t('STAKE')}}</span>
                      <p>{{betslip.betStake | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.betStake) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                      </p>
                  </div>
                  <div class="bslip-data-item big light" v-if="betslip.hasAchievedBonus">
                    <span>{{$t('POTENTIALBONUS')}}</span>
                    <p class="bslip-bonus-percent" v-if="betslip.bonusPercentageDisplayed != null">{{betslip.bonusPercentageDisplayed}}%</p>
                    <p>{{betslip.potentialBonus}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialBonus) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>

                  <div class="bslip-data-item big light"
                  v-if="betslipType === 'lotto' && tickets.length">
                    <span>{{$t('TOTALPOTENTIALPAYOUT')}}:</span>
                    <p>{{betslip.potentialPayout * tickets.length | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialPayout * tickets.length) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
                  <div class="bslip-data-item big">
                    <span>{{$t('POTENTIALPAYOUT')}}</span>
                    <p>{{betslip.potentialPayout | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialPayout) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
              </div>
              <template
                v-if="calculateEurConversion">
                <br>
                  <div class="bslip-data-item light">
                        <span>
                            {{$t('EUR_FIXED_CONVERSION_RATE_NOTICE')}}
                        </span>
                    </div>
              </template>
            </div>
            <div v-else>
              <div class="dbslip-data" v-if="showBetslipCalculation">
                  <div class="bslip-data-item" v-if="betslipType === 'lotto' && tickets.length">
                      <p>{{$t('TOTALPAYIN')}}: </p>
                      <p>{{betslip.payin * tickets.length | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.payin * tickets.length) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                      </p>
                      <p ref_testcafe="totalPayinFrontend" style="display: none">{{betslip.payin}}</p>
                  </div>
                  <div class="bslip-data-item" v-if="betslip.betslipDef == 'simple' && betslipType != 'lotto' && betslipType != 'vhorse'">
                      <p>{{$t('NUMBEROFEVENTS')}}: </p>
                      <p>{{betslipItems.length}}</p>
                  </div>
                  <div class="bslip-data-item" v-if="betslip.betslipDef == 'combination'">
                      <p>{{$t('COMBINATIONNUMBER')}}: </p>
                      <p ref_testcafe="numberOfCombinationsFrontend">{{betslip.numberOfCombinations}}</p>
                  </div>
                  <div class="bslip-data-item big light">
                    <p>{{$t('STAKE')}}: </p>
                    <p ref_testcafe="stakeFrontend">{{betslip.betStake | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.betStake) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
                  <div class="bslip-data-item" v-if="betslip.betslipDef === 'simple' || betslipType === 'lotto'">
                      <p>{{$t('TOTALODD')}}: </p>
                      <p ref_testcafe="totalOddFrontend">{{betslip.totalCoefficient | formatNum(4)}}</p>
                  </div>
                      <div class="bslip-data-item"
                      v-if="betslip.hasAchievedBonus">
                    <div class="ticket-bonus">
                        <span class ="bonus-badge" v-if="betslip.betslipDef === 'combination'" >{{$t('MAX_BONUS')}}&nbsp;</span>
                        <span v-else>{{$t('BONUS')}}&nbsp;</span>
                        <div class="bonus-badge" v-if="betslip.bonusPercentageDisplayed">{{betslip.bonusPercentageDisplayed}}%</div>
                    </div>
                        <p>
                            &nbsp;{{betslip.potentialBonus | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                            <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialBonus) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                        </p>
                  </div>
                  <div class="bslip-data-item" v-if="betslip.handlingFeePercentage">
                      <p>{{$t('TICKETCDA')}}: </p>
                      <p ref_testcafe="taxFrontend">{{betslip.handlingFee | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.handlingFee) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                      </p>
                  </div>
                  <div class="bslip-data-combinations" ref_testcafe="systemCombinationsFrontend" v-if="betslip.betslipType == 'lotto' && Object.keys(betslip.lottoHitBallWins).length">
                    <div class="bslip-data-item" v-for="(win, i) in betslip.lottoHitBallWins" :key="i">
                      <p>{{$t('GUESSEDNUMBERCOUNT', {num: i})}}: </p>
                     <p class="bslip-ball-hit-amount">{{win.winTaxed | formatNum}} ({{win.win | formatNum}}) {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(win.winTaxed) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                     </p>
                    </div>
                  </div>
                  <div class="bslip-data-item">
                    <p>{{$t('POTENTIALWIN')}}:</p>
                    <p ref_testcafe="potentialWinFrontend">{{betslip.potentialWin | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialWin) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
                  <div class="bslip-data-item">
                    <p>{{$t('WINTAX')}}:</p>
                    <p ref_testcafe="winTaxFrontend">{{betslip.payoutTax | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.payoutTax) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                  </div>
                  <div class="bslip-data-item big payout-text">
                    <p>{{$t('POTENTIALPAYOUT')}}:</p>
                    <p>{{betslip.potentialPayout | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialPayout) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                        </p>
                    <p ref_testcafe="potentialPayoutFrontend" style="display: none">{{betslip.potentialPayout}}</p>
                  </div>
                  <div class="bslip-data-item"
                  v-if="betslipType === 'lotto' && tickets.length">
                    <p>{{$t('TOTALPOTENTIALPAYOUT')}}:</p>
                    <p>{{betslip.potentialPayout * tickets.length | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}
                        <template v-if="calculateEurConversion">
                            <br>
                            {{getEurValue(betslip.potentialPayout * tickets.length) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                        </template>
                    </p>
                    <p ref_testcafe="totalPotentialPayoutFrontend" style="display: none">{{betslip.potentialPayout * tickets.length}}</p>
                  </div>
                  <div class="bslip-data-item light"
                    v-if="calculateEurConversion">
                        <span>
                            {{$t('EUR_FIXED_CONVERSION_RATE_NOTICE')}}
                        </span>
                    </div>
                </div>
            </div>
          </div>

          <div class="bslip-shop-online" v-if="globals && globals.publicConfig && globals.publicConfig.localeSetup && globals.publicConfig.localeSetup.onlineTicketOverrideEnabled && !showBalance">
              <div class="form-group">
                <div class="switch-main">
                  <label for="switch-normal">{{$t('BETINSHOP')}}</label>
                  <input type="checkbox" class="switch" id="switch-normal" :ref_testcafe="`switchIs${betslip.betslipOnline}`" v-model="ticketOnline" :disabled="ticketIsLoading">
                  <label for="switch-normal" class="betonline-switch" ref_testcafe="onlineOrShopSwitch"></label>
                  <label class="right">{{$t('BETONLINE')}}</label>
                </div>
              </div>
          </div>

          <div class="bslip-place-bet"
          v-if="betslipItems.length || (allTicketErrors.length)"
          :class="{'is-blocked': (allTicketErrors.length || !showBetslipCalculation)}"
          >
            <template v-if="!isMobile">
                <BetslipErrors
                v-if="allTicketErrors.length"
                :errors="allTicketErrors" />
            </template>
            <form action="" class="bslip-buttons-form" v-if="betslipItems.length">
                <a class="button button-grey-first delete-ticket-btn" ref_testcafe="deleteTicket"
                v-on:click.prevent="clearItems"
                v-if="!betConfirmDialogActive">
                    <i class="iconset icon-delete"></i>
                </a>

                <template v-if="!allTicketErrors.length">
                    <a v-on:click.prevent="submitTicket()"
                    class="button button-blue" ref_testcafe="submitBet"
                    v-if="!ticketIsLoading && !betConfirmDialogActive">
                        <i class="iconset icon-betslip" :class="ticketSavedClass"></i>
                    {{(betslip.betslipOnline == 'online') ? $t('PLACEONLINETICKET') : $t('PLACETEMPLATETICKET')}}
                    </a>
                    <div class="betslip-confirm-bet-container"
                    v-else-if="!ticketIsLoading && betConfirmDialogActive">
                        <a v-on:click.prevent="confirmSubmitTicket(false)"
                        class="button button-grey-first ticket-cancel">
                            {{$t('DECLINE_BET_CONFIRMATION')}}
                        </a>
                        <a v-on:click.prevent="confirmSubmitTicket(true)"
                        class="button button-blue" ref_testcafe="confirmOnlineBet">
                            {{$t('ACCEPT_BET_CONFIRMATION')}}
                        </a>
                    </div>
                    <a class="button button-blue" v-else><img src="../../../assets/img/loading.svg" class="loading-icon mr-sm">
                    {{$t('PLEASEWAIT')}}</a>
                    <input style="width: 0px; height: 0px; opacity: 0;" ref="placebet" />
                </template>
                <template v-else>
                    <a class="button button-blue is-blocked">
                        <img src="../../../assets/img/locked.svg"> {{(betslip.betslipOnline == 'online') ? $t('PLACEONLINETICKET') : $t('PLACETEMPLATETICKET')}}
                    </a>
                </template>
            </form>
          </div>

          <div class="auto-accept-odd" v-if="betslipItems.length && betslipType === 'sport'">
            <div class="auto-accept">
              <label class="switch" ref_testcafe="autoAcceptOdds">
                <input type="checkbox" :checked="betslip.autoAcceptChanges" @click="setAutoAcceptOddsValue">
                <span class="slider round"></span>
                <span class="absolute-yes">{{$t('AUTOACCEPT_ON')}}</span>
                <span class="absolute-no">{{$t('AUTOACCEPT_OFF')}}</span>
              </label>
              <p class="info-text">{{$t('AUTOACCEPTODDCHANGES')}}</p>
            </div>
          </div>
          <div class="mt-3"
            v-if="(globals
            && globals.publicConfig
            && globals.publicConfig.website
            && globals.publicConfig.website.displayBetsHistoryButton)
            && (globals.groupId !== undefined
            && globals.groupId !== 2)
            && isMobile">
                <div class="mybets-button-bslip">
                <a class="button button-grey-first"
                @click="toggleMybetsModal(true)">
                <img class="" src="../../../assets/img/icon-ticket-all.svg">
                        {{$t('SHOW_MYBETS_HISTORY')}}
                    </a>
                </div>
            </div>
        </div>
        <!-- Ticket List Mobile -->
        <TicketList v-if="isMobile" v-bind:betsOpen="betsOpen" v-on:toggleBetsOpen="toggleBetsOpen" />
      </div>
      <div
        v-if="(globals
        && globals.publicConfig
        && globals.publicConfig.website
        && globals.publicConfig.website.displayBetsHistoryButton)
        && (globals.groupId !== undefined
        && globals.groupId !== 2)
        && !isMobile">
        <div class="mybets-button-bslip">
            <a class="button button-grey-first"
            @click="toggleMybetsModal(true)">
            <img class="" src="../../../assets/img/icon-ticket-all.svg">
                {{$t('SHOW_MYBETS_HISTORY')}}
            </a>
        </div>
    </div>
    </div>
    </div>
    <!-- Ticket List Desktop -->
    <TicketList v-if="!isMobile" v-bind:betsOpen="betsOpen" v-on:toggleBetsOpen="toggleBetsOpen" />

  </div>
</vue-scroll>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

import moment from 'moment-timezone';
import Cookies from 'js-cookie';
import Betslip from '@om-retail/betslip';
// import Betslip from '../../../../flex-betslip/dist/index';
import BetslipItem from './BetslipItem.vue';
import BetslipLottoItem from './BetslipLottoItem.vue';
import TicketList from './TicketList.vue';
import BetslipErrors from './BetslipErrors.vue';
import TicketsCreatedList from './TicketsCreatedList.vue';
import TicketLottoExtendedItem from './BetslipLottoExtendedItem.vue';

export default {
    name: 'Betslip',
    components:
    {
        BetslipItem,
        BetslipLottoItem,
        TicketList,
        BetslipErrors,
        TicketsCreatedList,
        TicketLottoExtendedItem,
    },
    props: [
        'resultsRoute',
    ],
    data()
    {
        return {
            systemShown: false,
            combsShown: false,
            betslipOpen: false,
            ticketCode: null,
            betsOpen: true,
            ticketSavedClass: '',
            calcDisplayedBetAmount: 2,
            previousFormattedBetAmount: '2',
            defaultBetslipDecimalsCount: 2,
            betAmountInputFocused: false,
            mtsMaxStakeValue: null,
            betConfirmDialogActive: false,
            placedTicketsPopupDisplayed: false,
            createdTickets: [],
            itemsSortOrder: [],
            allowUnregisteredOnlineTickets: false,
            ticketOnline: false,
            showBetslipCalculation: true,
            showCombinations: false,
            tickets: [],
            allTicketErrors: [],
        };
    },
    created()
    {
        const me = this;
        me.checkAutoAcceptOddCookie();

        if (me.betslip.payin)
        {
            me.calcDisplayedBetAmount = me.betslip.payin;
        }
        else
        {
            me.betslip.changePayin(me.calcDisplayedBetAmount);
        }

        if (me.betslipType)
        {
            if (me.betslipType === 'sport')
            {
                // TODO solve this on betslip store module
                // me.toggleSportTicketUpdates();
            }
            else if (me.betslipType === 'vhorse')
            {
                me.toggleBetslipDef('simple');
            }
            else
            {
                me.toggleBetslipDef('combination');
            }
        }

        if (me.globals
        && me.globals.publicConfig
        && me.globals.publicConfig.website
        && me.globals.publicConfig.website.shopOnlineSelectorOptions
        && me.globals.publicConfig.website.shopOnlineSelectorOptions.defaultOnlineSelectorValue)
        {
            window.emit('betslipToggleOnlineOffline', {
                type: me.globals.publicConfig.website.shopOnlineSelectorOptions.defaultOnlineSelectorValue,
                query: me.$route.query,
            });
        }

        if (me.betslip.betslipOnline === 'online')
        {
            me.ticketOnline = true;
        }

        me.refreshTickets();

        me.allowUnregisteredOnlineTickets = (me.globals.publicConfig !== undefined
            && me.globals.publicConfig.website !== undefined
            && me.globals.publicConfig.website.shopOnlineSelectorOptions !== undefined
            && me.globals.publicConfig.website.shopOnlineSelectorOptions.allowUnregisteredOnlineTickets !== undefined)
            ? me.globals.publicConfig.website.shopOnlineSelectorOptions.allowUnregisteredOnlineTickets : false;

        me.$nextTick(() =>
        {
            // me.setDefaultTicketOnline();
            if (me.canPlaceOnlineTicket)
            {
                me.setDefaultTicketOnline();
            }
        });

        this.checkLottoTicket();
    },
    methods: {
        ...mapActions({
            clearItemsInit: 'clearItems',
            submitTicketInit: 'submitTicket',
            toggleSportTicketUpdates: 'toggleSportTicketUpdates',
            subscribeToTicketMatch: 'subscribeToTicketMatch',
            removeTicketSubscriptionEvent: 'removeTicketSubscriptionEvent',
            removeSelectedLotteryDraws: 'removeSelectedLotteryDraws',
            clearSelectedLotteryData: 'clearSelectedLotteryData',
            setTicketData: 'setTicketData',
            clearSavedLottoNumbers: 'clearSavedLottoNumbers',
            toggleMybetsModal: 'toggleMybetsModal',
            setLastSelectedTicketOnline: 'setLastSelectedTicketOnline',
            getTicketData: 'getTicketData',
            toggleBetslipDefInit: 'toggleBetslipDef',
        }),
        openHelp(val = null)
        {
            this.$emit('togglehelppagestep', val);
        },
        async sortItems()
        {
            if (this.betslipType == null
            || this.betslipType === 'mix')
            {
                return;
            }

            const items = [
                ...this.betslipItems,
            ];

            let sortKey = 'originalIndex';

            if (this.globals.publicConfig
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.ticketItemsOrderingPresets
            && this.globals.publicConfig.website.ticketItemsOrderingPresets.sortingEnabled
            && this.globals.publicConfig.website.ticketItemsOrderingPresets[this.betslipType])
            {
                sortKey = this.globals.publicConfig.website.ticketItemsOrderingPresets[this.betslipType];
            }

            let i = 0;
            for (const item of items)
            {
                item.sortValue = item.originalIndex;
                item.preSortIndex = i;
                i += 1;

                if (sortKey === 'eventName')
                {
                    item.sortValue = item.eventName.toString().toLowerCase().trim();
                }
                else if (sortKey === 'timestamp')
                {
                    item.sortValue = moment.utc(item.eventDate).valueOf();
                }
                else if (sortKey === 'outcomeName')
                {
                    if (this.betslipType === 'lotto')
                    {
                        item.sortValue = parseInt(item.meta.selectedBall, 10);
                    }
                    else
                    {
                        item.sortValue = item.meta.outcomeName.toString().toLowerCase().trim();
                    }
                }
                else if (sortKey === 'value')
                {
                    item.sortValue = parseFloat(item.meta.coefficient);
                }
            }

            items.stableSort((a, b) =>
            {
                if (a.sortValue < b.sortValue)
                {
                    return -1;
                }

                if (a.sortValue > b.sortValue)
                {
                    return 1;
                }

                return 0;
            });

            const sortingIndexes = [];

            for (const item of items)
            {
                sortingIndexes.push(item.preSortIndex);
            }

            this.betslip.sortBetslipItems({
                sortingIndexes,
            });
        },
        countDecimals(value)
        {
            const splitMain = value.split('.');
            if (splitMain.length > 1)
            {
                return value.split('.')[1].length || 0;
            }
            return 0;
        },
        changeCalcDisplayedBetAmount(event)
        {
            const me = this;

            me.calcDisplayedBetAmount = event.target.value;
        },
        inputPayinSelectAll(event)
        {
            const me = this;
            me.betAmountInputFocused = true;

            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(() =>
            {
                if (event)
                {
                    event.target.select();
                }
            }, 50);
        },
        checkAutoAcceptOddCookie()
        {
            const me = this;
            const cookieVal = Cookies.get('autoAcceptOddChange');

            if (cookieVal != null)
            {
                const autoAcceptCookie = Boolean(JSON.parse(cookieVal));
                if (autoAcceptCookie !== undefined && me.betslipType === 'sport')
                {
                    me.betslip.autoAcceptChanges = autoAcceptCookie;
                }
            }
            else
            {
                me.betslip.autoAcceptChanges = true;
            }
        },
        setAutoAcceptOddsValue()
        {
            const me = this;
            // me.changeTicketAutoAcceptValue();
            me.betslip.changeAutoAcceptValue();
            const expireAfter = me.globals.publicConfig.website.autoAcceptOddChangeCookieExpire || 365;
            if (me.betslipType === 'sport')
            {
                Cookies.set('autoAcceptOddChange', me.betslip.autoAcceptChanges, {
                    expires: expireAfter,
                    sameSite: 'None',
                    secure: true,
                });
            }
        },
        reloadAllTicketErrors()
        {
            const me = this;

            const errors = [];

            let newDisplayedBetAomunt = null;

            if (me.betslipType === 'lotto')
            {
                for (const ticket of me.tickets)
                {
                    if (ticket.ticket !== undefined)
                    {
                        if (newDisplayedBetAomunt === null
                        && ticket.ticket.payin !== me.betslip.payin
                        && me.betslip.maxWinCalculatedLast.confirmedStake != null
                        && me.betslip.maxWinCalculatedLast.confirmedStake !== me.betslip.payin)
                        {
                            newDisplayedBetAomunt = ticket.betslip.payin;
                        }

                        if (ticket.ticket.errors !== undefined
                        && ticket.ticket.errors.length)
                        {
                            for (const error of ticket.ticket.errors)
                            {
                                if (error.submitTicketError === undefined
                                || error.submitTicketError === false)
                                {
                                    continue;
                                }

                                const errorOut = {
                                    ...error,
                                };

                                let eventId;

                                if (ticket.ticket.items
                                && ticket.ticket.items.length
                                && ticket.ticket.items[0]
                                && ticket.ticket.items[0].eventId)
                                {
                                    eventId = ticket.ticket.items[0].eventId;
                                }

                                if (typeof errorOut.text === 'string')
                                {
                                    errorOut.text = {
                                        text: errorOut.text,
                                        params:
                                        {
                                            eventId,
                                        },
                                    };
                                }
                                else
                                {
                                    errorOut.text.eventId = eventId;
                                }

                                errors.push(errorOut);
                            }
                        }
                    }
                }

                if (newDisplayedBetAomunt !== null)
                {
                    // me.betslip.displayedBetAmount = newDisplayedBetAomunt;
                    me.betslip.changePayin(newDisplayedBetAomunt.toString());
                }
            }

            for (const error of me.betslip.errors)
            {
                errors.push(error);
            }

            me.allTicketErrors = errors;
        },
        toggleCombination(combination)
        {
            const me = this;

            me.betslip.toggleCombination(
                combination,
                {
                    saveLastAction: true,
                },
            );
        },
        setTicketDisplayedBetAmount()
        {
            const me = this;

            const val = me.calcDisplayedBetAmount;

            if (val == null)
            {
                me.$nextTick(() =>
                {
                    if (me.betslip.payin != null)
                    {
                        me.calcDisplayedBetAmount = me.betslip.payin;
                    }
                    else if (me.globals.publicConfig
                    && me.globals.publicConfig.localeSetup
                    && me.globals.publicConfig.localeSetup.defaultBetslipStake)
                    {
                        me.calcDisplayedBetAmount = me.globals.publicConfig.localeSetup.defaultBetslipStake;
                    }
                });
                return;
            }

            const isValid = /[0-9,.]$/.test(val);

            if (!isValid)
            {
                me.calcDisplayedBetAmount = val.toString().substr(0, val.length - 1);
            }
            /* eslint-disable eqeqeq */
            else if (val == parseInt(val, 10))
            {
                /* if (me.globals
                && me.globals.publicConfig
                && me.globals.publicConfig.ticketSetup
                && me.globals.publicConfig.ticketSetup.web
                && me.globals.publicConfig.ticketSetup.web[me.betslipType]
                && me.globals.publicConfig.ticketSetup.web[me.betslipType].maxStake)
                {
                    const { maxStake } = me.globals.publicConfig.ticketSetup.web[me.betslipType];

                    if (parseFloat(val) > parseFloat(maxStake))
                    {
                        me.calcDisplayedBetAmount = parseFloat(maxStake);
                        return;
                    }
                } */

                me.betslip.changePayin(parseInt(val, 10));
            }
            else if (val == parseFloat(val))
            {
                const valStr = val.toString();
                let spliceIndex = false;
                let valStrSplit = '';

                if (valStr.indexOf(',') !== -1)
                {
                    valStrSplit = valStr.split(',');

                    if (valStrSplit[1].length > 2)
                    {
                        spliceIndex = valStr.indexOf(',');
                    }
                }
                else if (valStr.indexOf('.') !== -1)
                {
                    valStrSplit = valStr.split('.');

                    if (valStrSplit[1].length > 2)
                    {
                        spliceIndex = valStr.indexOf('.');
                    }
                }

                if (spliceIndex !== false)
                {
                    me.calcDisplayedBetAmount = valStr.substr(0, spliceIndex + 3);
                    return;
                }

                /* if (me.globals
                && me.globals.publicConfig
                && me.globals.publicConfig.ticketSetup
                && me.globals.publicConfig.ticketSetup.web
                && me.globals.publicConfig.ticketSetup.web[me.betslipType]
                && me.globals.publicConfig.ticketSetup.web[me.betslipType].maxStake)
                {
                    const { maxStake } = me.globals.publicConfig.ticketSetup.web[me.betslipType];

                    if (parseFloat(val) > parseFloat(maxStake))
                    {
                        me.calcDisplayedBetAmount = parseFloat(maxStake);
                        return;
                    }
                } */

                me.betslip.changePayin(parseFloat(val));
            }
            /* eslint-enable eqeqeq */
            else
            {
                const valStr = val.toString();
                if (valStr.substring(valStr.length - 1, valStr.length) === '.'
                || valStr.substring(valStr.length - 1, valStr.length) === ',')
                {
                    const delimiterCount = (val.match(/[.,]/g) || []).length;
                    if (delimiterCount > 1 || valStr.length === 1)
                    {
                        me.calcDisplayedBetAmount = val.toString().substr(0, val.length - 1);
                        return;
                    }
                }

                if (valStr.substring(valStr.length - 1, valStr.length) === '.')
                {
                    return;
                }
                if (valStr.substring(valStr.length - 1, valStr.length) === ',')
                {
                    me.calcDisplayedBetAmount = valStr.replace(',', '.');
                }
            }
        },
        clearItems()
        {
            const me = this;

            if (me.betslipType === 'lotto')
            {
                me.clearSelectedLotteryData();
                me.clearSavedLottoNumbers();
            }
            me.clearItemsInit();
        },
        async refreshTickets(force = false)
        {
            const me = this;

            if (me.betslipType !== 'lotto')
            {
                me.tickets = [];
                return;
            }

            const clonedTicketData = await me.betslip.getClonedBetslipData();

            const ticketsOut = [];

            if (this.betslip
            && this.betslipConfig
            && (!this.betslip.errors.length || force))
            {
                for (const draw of me.selectedLotteryDraws)
                {
                    if (me.allLotteries[me.selectedLottery] !== undefined
                    && me.allLotteries[me.selectedLottery].lottos !== undefined
                    && me.allLotteries[me.selectedLottery].lottos[draw] !== undefined)
                    {
                        const lotto = me.allLotteries[me.selectedLottery].lottos[draw];

                        if (moment.utc(lotto.utcDate).valueOf() < moment.utc().valueOf())
                        {
                            continue;
                        }

                        // TODO should solve lowercase constructor
                        // eslint-disable-next-line new-cap
                        // const ticketOut = new Ticket.ticket(me.globals.publicConfig.ticketSetup.web);
                        const ticketOut = new Betslip.Betslip({
                            ...this.betslipConfig,
                            rawConfiguration: true,
                        });
                        ticketOut.setDeviceType('web');

                        const newLottoItems = [];

                        for (const singleItem of clonedTicketData.items)
                        {
                            newLottoItems.push({
                                ...singleItem,
                                eventId: lotto.lottoOfferId,
                                eventDate: lotto.utcDate,
                            });
                        }

                        // eslint-disable-next-line no-await-in-loop
                        const cloneDataResponse = await ticketOut.setClonedBetslipData({
                            ...clonedTicketData,
                            items: newLottoItems,
                            skipCombinationCheck: true,
                        });

                        if (cloneDataResponse.error)
                        {
                            continue;
                        }

                        // ticketOut.ticketType = 'lotto';

                        // ticketOut.setTicketLoading(false);

                        // ticketOut.mergeConfig('lotto');
                        // ticketOut.recreateTicket();

                        for (const ticketTemp of me.tickets)
                        {
                            if (ticketTemp.id === draw)
                            {
                                ticketOut.errors = ticketTemp.ticket.errors;
                                ticketOut.betslipLoading = ticketTemp.ticket.betslipLoading;
                                ticketOut.betslipSubmitting = ticketTemp.ticket.betslipSubmitting;
                                break;
                            }
                        }

                        ticketsOut.push({
                            id: draw,
                            ticket: ticketOut,
                            startDateTimestamp: moment(lotto.utcDate).valueOf(),
                            eventDate: lotto.utcDate,
                        });
                    }
                }
            }

            if (ticketsOut.length > 1)
            {
                ticketsOut.sort((a, b) =>
                {
                    if (a.startDateTimestamp < b.startDateTimestamp)
                    {
                        return -1;
                    }

                    if (a.startDateTimestamp > b.startDateTimestamp)
                    {
                        return 1;
                    }

                    return 0;
                });
            }

            me.tickets = ticketsOut;
        },
        deleteTicket(id)
        {
            const me = this;

            me.removeSelectedLotteryDraws([
                {
                    lottoOfferId: id,
                },
            ]);
        },
        focusPlaceBet(event)
        {
            const me = this;

            if (event.keyCode === 13)
            {
                me.$refs.amountinputmobile.blur();

                if (me.$refs.placebet !== undefined)
                {
                    me.$nextTick(() =>
                    {
                        me.$refs.placebet.focus();
                        me.$refs.placebet.blur();
                    });
                }
            }
        },
        toggleBetslipDef(def)
        {
            const me = this;

            me.toggleBetslipDefInit(def);
            if (me.isMobile)
            {
                me.betsOpen = true;
            }
        },
        toggleBetsOpen(val)
        {
            const me = this;

            me.betsOpen = (val !== undefined) ? val : false;
        },
        toggleTicketType(type)
        {
            const me = this;

            if (me.ticketIsLoading)
            {
                return;
            }

            let typeOut = (me.betslip.betslipOnline === 'online') ? 'retail' : 'online';

            if (type !== undefined)
            {
                typeOut = type;
            }

            window.emit('betslipToggleOnlineOffline', {
                type: typeOut,
                query: me.$route.query,
            });
        },
        async mtsMaxStakeAction()
        {
            const me = this;

            if (me.mtsMaxStakeValue !== null)
            {
                me.betslip.payin = me.mtsMaxStakeValue;
            }
            else
            {
                const data = await me.betslip.submitBetslip({
                    getMtsMaxStake: true,
                    clientRequestTimestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss.SSS'),
                    userAgent: this.deviceUserAgent,
                });

                if (!data.error)
                {
                    me.mtsMaxStakeValue = data.maxStake;
                }
            }
        },
        async submitTicketsFromList(param = {})
        {
            const me = this;

            if (!this.preCheckBetConfirmation(param))
            {
                return;
            }

            me.createdTickets = [];

            me.betslip.setBetslipLoading(true);

            const createdTickets = [];

            let isFirst = true;

            if (me.betslipType === 'lotto')
            {
                const payinCheck = this.betslip.checkPayinLimits();

                if (!payinCheck.error)
                {
                    const params = {
                        // itemsSortOrder: null,
                        currency: me.playerdata.money.currency,
                        clientRequestTimestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss.SSS'),
                        userAgent: this.deviceUserAgent,
                    };

                    if (me.$route.query.username)
                    {
                        params.userId = me.$route.query.username;
                        params.sessionId = me.$route.query.token;
                        params.gameId = me.$route.query.gameId;
                    }

                    for (const ticket of me.tickets)
                    {
                        if (!ticket.ticket)
                        {
                            continue;
                        }

                        // eslint-disable-next-line no-await-in-loop
                        /* const createdTicket = await me.submitTicketAction({
                        ticket: ticket.ticket,
                        showPlacedTicketsPopup: true,
                        ...param,
                    }); */
                        // eslint-disable-next-line no-await-in-loop
                        const ticketSubmitData = await ticket.ticket.submitBetslip(
                            params,
                        );

                        if (isFirst
                    && ticketSubmitData.error
                    && ticketSubmitData.ruleCheckFailed !== undefined
                    && ticketSubmitData.ruleCheckFailed === true)
                        {
                            break;
                        }

                        isFirst = false;

                        if (!ticketSubmitData.error)
                        {
                            createdTickets.push(ticketSubmitData);
                        }

                    /* if (!ticketSubmitData.error)
                    {
                        createdTickets.push(ticketSubmitData.data);
                    } */
                    }
                }
            }

            if (createdTickets.length)
            {
                window.emit('betslipMade');

                if (createdTickets.length < 2
                && me.globals.publicConfig.website !== undefined
                && me.globals.publicConfig.website.ticketListOptions !== undefined
                && me.globals.publicConfig.website.ticketListOptions.ticketSubmitSuccessPopup)
                {
                    me.setTicketData(createdTickets[0]);
                }
                else
                {
                    me.createdTickets = createdTickets;
                    me.placedTicketsPopupDisplayed = true;
                }
            }

            me.betslip.setBetslipLoading(false);
        },
        preCheckBetConfirmation(param = {})
        {
            if (this.globals.publicConfig.website !== undefined
            && this.globals.publicConfig.website.forceTicketSubmitConfirmation !== undefined
            && this.globals.publicConfig.website.forceTicketSubmitConfirmation === true
            /* && this.globals.groupId !== undefined
            && this.globals.groupId !== 2
            && this.$route.query.username !== undefined */
            && this.canPlaceOnlineTicket
            && (param === undefined
            || param.betConfirmed === undefined
            || param.betConfirmed === false))
            {
                if (this.globals.publicConfig.website.forceOfflineTicketSubmitConfirmation === undefined
                || this.globals.publicConfig.website.forceOfflineTicketSubmitConfirmation === true
                || (this.betslip.betslipOnline === 'online'))
                {
                    this.betConfirmDialogActive = true;
                    return false;
                }
            }

            return true;
        },
        async submitTicket(param = {}, options = {})
        {
            if (!this.preCheckBetConfirmation(param))
            {
                return;
            }

            if (this.betslipType === 'lotto')
            {
                this.submitTicketsFromList(
                    {
                        ...param,
                        betConfirmed: true,
                    },
                    options,
                );
            }
            else
            {
                this.submitStandardTicket(
                    {
                        ...param,
                        betConfirmed: true,
                    },
                    options,
                );
            }
        },
        async submitStandardTicket(options = {})
        {
            const me = this;

            if (!me.showBetslipCalculation)
            {
                return;
            }

            const error = {
                text:
                {
                    text: 'USERNOTLOGGEDIN_TICKETCANNOTBESETAS_ONLINE',
                },
                button1:
                {
                    text:
                    {
                        text: 'OK',
                    },
                    callback()
                    {
                        me.betslip.hideBetslipError({
                            id: 'ticket_online_user_offline',
                        });
                    },
                },
                id: 'ticket_online_user_offline',
            };

            if (me.betslip.betslipOnline === 'retail'
            && me.hasLiveEvents)
            {
                error.text.text = 'TICKETHASLIVEEVENTS_MUSTBEONLINETICKET';

                me.betslip.showBetslipError(error);

                return;
            }

            if (!me.allowUnregisteredOnlineTickets
            && me.betslip.betslipOnline === 'online'
            && !me.canPlaceOnlineTicket)
            {
                me.betslip.showBetslipError(error);

                return;
            }

            let ticketSubmitSuccess = false;
            let ticketPopupDisplayData = null;
            let shouldDisplayTicketPopup = false;

            if (me.globals.publicConfig.website !== undefined
            && me.globals.publicConfig.website.ticketListOptions !== undefined
            && me.globals.publicConfig.website.ticketListOptions.ticketSubmitSuccessPopup)
            {
                shouldDisplayTicketPopup = true;
            }

            const params = {
                currency: me.playerdata.money.currency,
                clientRequestTimestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss.SSS'),
                userAgent: this.deviceUserAgent,
            };

            if (me.$route.query.username)
            {
                params.userId = me.$route.query.username;
                params.sessionId = me.$route.query.token;
                params.gameId = me.$route.query.gameId;
            }

            const ticketSubmitData = await me.betslip.submitBetslip(
                params,
                options,
            );

            if (!ticketSubmitData.error)
            {
                ticketSubmitSuccess = true;
                ticketPopupDisplayData = ticketSubmitData;
            }

            /* if (me.betslipType === 'lotto')
            {
                const ticketPlaceData = await me.betslip.submitLottoSelectedDrawsBetslip(
                    params,
                    options,
                );
                const createdTickets = ticketPlaceData.tickets;

                if (createdTickets.length)
                {
                    ticketSubmitSuccess = true;

                    if (createdTickets.length < 2
                    && shouldDisplayTicketPopup)
                    {
                        ticketPopupDisplayData = {
                            data: createdTickets[0],
                        };
                    }
                    else
                    {
                        me.createdTickets = createdTickets;
                        me.placedTicketsPopupDisplayed = true;
                    }
                }
            }
            else
            {
                const ticketSubmitData = await me.betslip.submitBetslip(
                    params,
                    options,
                );

                if (!ticketSubmitData.error)
                {
                    ticketSubmitSuccess = true;
                    ticketPopupDisplayData = ticketSubmitData;
                }
            } */

            if (ticketSubmitSuccess)
            {
                window.emit('betslipMade');

                me.ticketSavedClass = 'submited';

                setTimeout(() =>
                {
                    me.ticketSavedClass = '';
                }, 3000);

                if (shouldDisplayTicketPopup && ticketPopupDisplayData != null)
                {
                    me.setTicketData(ticketPopupDisplayData);
                }
            }
        },
        confirmSubmitTicket(confirm = false)
        {
            const me = this;

            me.betConfirmDialogActive = false;

            if (confirm)
            {
                if (this.betslipType === 'lotto')
                {
                    me.submitTicketsFromList({
                        betConfirmed: true,
                    });
                }
                else
                {
                    me.submitStandardTicket({
                        betConfirmed: true,
                    });
                }
            }
        },
        async getTicket(params = {})
        {
            const me = this;
            let ticketCode = null;

            if (me.ticketCode !== null)
            {
                ticketCode = me.ticketCode;
            }

            if (params.ticketCode !== undefined
            && params.ticketCode !== null)
            {
                ticketCode = params.ticketCode;
            }

            if (ticketCode == null)
            {
                return;
            }

            if (ticketCode.includes(' '))
            {
                ticketCode = ticketCode.split(' ').join('');
            }

            /* me.getTicketInit({
                ticketCode,
            }); */

            // me.setTicketData(null);

            /* const ticketData = await me.betslip.getBetslip({
                ticketCode,
            }); */

            await this.getTicketData({
                ticketCode,
            });

            // me.setTicketData(ticketData);
        },
        changePredefinedPayin(num)
        {
            this.betslip.changePayin(num);
        },
        toggleModal(status)
        {
            const me = this;
            me.$store.commit('toggleModal', { status });
        },
        resetMtsMaxStake()
        {
            const me = this;
            me.mtsMaxStakeValue = null;
        },
        setDefaultTicketOnline()
        {
            const me = this;

            if (me.lastSelectedTicketOnline != null)
            {
                me.toggleTicketType(me.lastSelectedTicketOnline);
                return;
            }

            if (me.globals.publicConfig
            && me.globals.publicConfig.website
            && me.globals.publicConfig.website.shopOnlineSelectorOptions)
            {
                if (me.canPlaceOnlineTicket)
                {
                    if (me.globals.publicConfig.website.shopOnlineSelectorOptions.autoSelectedTicketOnlinePlayer)
                    {
                        me.toggleTicketType(
                            me.globals.publicConfig
                                .website.shopOnlineSelectorOptions.autoSelectedTicketOnlinePlayer,
                        );
                    }
                }
                else if (me.globals.publicConfig.website.shopOnlineSelectorOptions.autoSelectedTicketOnlineUnregistered)
                {
                    me.toggleTicketType(
                        me.globals.publicConfig.website.shopOnlineSelectorOptions.autoSelectedTicketOnlineUnregistered,
                    );
                }
            }
        },
        getEurValue(val)
        {
            if (this.calculateEurConversion)
            {
                const eurCoeff = parseFloat(this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRate);

                return parseFloat(val) / eurCoeff;
            }

            return 0;
        },
        allLottoDraws()
        {
            if (this.allLotteries
            && this.selectedLottery
            && this.allLotteries[this.selectedLottery]
            && this.allLotteries[this.selectedLottery].lottos)
            {
                return this.allLotteries[this.selectedLottery].lottos;
            }

            return null;
        },
        checkLottoTicket()
        {
            this.betConfirmDialogActive = false;

            for (const item of this.betslip.items)
            {
                if (item.type === 'lotto')
                {
                    if (this.betslip.betslipDef !== 'combination')
                    {
                        this.toggleBetslipDef('combination');
                    }

                    this.showCombinations = true;
                }

                break;
            }
        },
    },
    watch:
    {
        betslipItemsCount(val, oldVal)
        {
            if (oldVal != null
            && val !== oldVal)
            {
                this.sortItems();
            }
        },
        'betslip.errors'()
        {
            const me = this;

            if (me.betslipType !== 'lotto')
            {
                me.allTicketErrors = me.betslip.errors;
            }
            else
            {
                me.reloadAllTicketErrors();
            }
        },
        tickets:
        {
            handler()
            {
                const me = this;

                me.reloadAllTicketErrors();
            },
            deep: true,
        },
        selectedLotteryDraws()
        {
            this.refreshTickets(!this.ticketIsLoading);
        },
        ticketOnline(val)
        {
            const me = this;
            const typeToggle = (val) ? 'online' : 'retail';

            me.toggleTicketType(typeToggle);

            me.$nextTick(() =>
            {
                if (me.betslip.betslipOnline !== typeToggle)
                {
                    me.ticketOnline = !val;
                }
            });
        },
        'betslip.totalCoefficient'()
        {
            const me = this;
            if (me.betslip.betslipDef === 'simple')
            {
                me.resetMtsMaxStake();
            }

            me.betConfirmDialogActive = false;
            this.refreshTickets(!this.ticketIsLoading);
        },
        'betslip.combinations'(val, oldVal)
        {
            const me = this;
            if (me.betslip.betslipDef === 'combination')
            {
                me.resetMtsMaxStake();

                const lastItem = this.betslip.combinations[this.betslip.combinations.length - 1];
                if (!oldVal.length && lastItem !== undefined && !lastItem.selected)
                {
                    this.toggleCombination(lastItem);
                }
            }

            me.betConfirmDialogActive = false;
            me.refreshTickets();
        },
        betslipItems:
        {
            handler()
            {
                const me = this;
                me.resetMtsMaxStake();

                this.checkLottoTicket();

                this.refreshTickets(!this.ticketIsLoading);

                /* if (me.ticketType !== 'sport')
                {
                    return;
                }

                for (const matchId of me.subscribedTicketEvents)
                {
                    let matchFound = false;

                    for (let i = 0; i < me.betslip.items.length; i += 1)
                    {
                        const item = me.betslip.items[i];
                        if (parseInt(item.eventId, 10) === parseInt(matchId, 10))
                        {
                            matchFound = true;
                            break;
                        }
                    }

                    if (!matchFound)
                    {
                        me.removeTicketSubscriptionEvent(matchId);
                    }
                }

                const tags = {};

                for (let i = 0; i < me.betslip.errors.length; i += 1)
                {
                    const ticketError = me.betslip.errors[i];

                    if (ticketError.tags !== undefined && ticketError.tags.length)
                    {
                        for (const tag of ticketError.tags)
                        {
                            // TODO handle all other types too
                            if (tag.includes('match_sport_'))
                            {
                                const [, tagMatchId] = tag.split('_');
                                tags[parseInt(tagMatchId, 10)] = tag;
                            }
                        }
                    }
                }

                for (let i = 0; i < me.betslip.items.length; i += 1)
                {
                    const item = me.betslip.items[i];
                    if (item.type !== 'sport'
                    || item.subtype === 'outrights')
                    {
                        continue;
                    }

                    if (me.subscribedTicketEvents.indexOf(item.matchId) === -1)
                    {
                        me.subscribeToTicketMatch(item.matchId);
                    }

                    if (tags[item.matchId] === undefined)
                    {
                        // TODO handle other types too
                        me.betslip.hideBetslipError({
                            tags: [
                                `match_sport_${item.matchId}`,
                            ],
                        });
                    }
                }

                // TODO
                // me.betslip.updatePendingItemOddChangesList();

                me.refreshTickets(); */
            },
            deep: true,
        },
        'betslip.payin':
        {
            handler(val)
            {
                const me = this;
                this.$nextTick(() =>
                {
                    if (val)
                    {
                        me.calcDisplayedBetAmount = val;
                        me.setTicketDisplayedBetAmount();
                    }

                    me.betConfirmDialogActive = false;

                    this.refreshTickets(!this.ticketIsLoading);
                });
            },
            deep: true,
        },
        'betslip.betslipDef'()
        {
            const me = this;
            me.systemShown = false;
            me.resetMtsMaxStake();

            me.betConfirmDialogActive = false;

            if (this.betslip.betslipDef === 'combination')
            {
                this.showCombinations = true;
            }
            else if (!me.betslip || !me.betslip.items || !me.betslip.items.length)
            {
                this.showCombinations = false;
            }
            else
            {
                this.showCombinations = false;
            }

            this.refreshTickets(!this.ticketIsLoading);

            /* for (const item of me.betslip.items)
            {
                const itemOfferType = (item.type === 'outrights') ? 'sport' : item.type;

                if (me.betslipType !== itemOfferType)
                {
                    this.showCombinations = false;
                    break;
                }
            } */
        },
        'betslip.betslipOnline'(val)
        {
            const me = this;

            if (val === 'online')
            {
                me.ticketOnline = true;
            }
            else
            {
                me.ticketOnline = false;
            }

            me.setLastSelectedTicketOnline(val);
            me.resetMtsMaxStake();

            me.betConfirmDialogActive = false;

            this.refreshTickets(!this.ticketIsLoading);
        },
        'betslip.potentialWin'()
        {
            this.refreshTickets(!this.ticketIsLoading);
        },
        calcDisplayedBetAmount(val)
        {
            const me = this;
            if (!val)
            {
                // me.showBetslipCalculation = false;
            }
            else
            {
                me.showBetslipCalculation = true;

                me.setTicketDisplayedBetAmount();
            }
        },
        betAmountInputFocused(val)
        {
            const me = this;

            if (!val)
            {
                me.setTicketDisplayedBetAmount();

                if (!me.calcDisplayedBetAmount)
                {
                    return;
                }
                const betAmountDisplayed = me.calcDisplayedBetAmount.toString();
                let betAmountDisplayedNew = null;

                if (betAmountDisplayed.substring(betAmountDisplayed.length - 1, betAmountDisplayed.length) === '.'
                || betAmountDisplayed.substring(betAmountDisplayed.length - 1, betAmountDisplayed.length) === ',')
                {
                    betAmountDisplayedNew = betAmountDisplayed.substr(0, betAmountDisplayed.length - 1);
                }

                if (betAmountDisplayedNew)
                {
                    me.calcDisplayedBetAmount = betAmountDisplayedNew;
                }
            }
        },
        'globals.groupId'()
        {
            const me = this;

            me.$nextTick(() =>
            {
                me.setDefaultTicketOnline();
            });
        },
        canPlaceOnlineTicket(val)
        {
            if (val === false)
            {
                window.emit('betslipToggleOnlineOffline', {
                    type: 'offline',
                });
            }
        },
        betslipOpen()
        {
            this.checkLottoTicket();
        },
    },
    computed:
    {
        ...mapGetters({
            betslipConfig: 'betslipConfig',
            betslip: 'betslip',
            isMobile: 'isMobile',
            globals: 'globals',
            subscribedTicketEvents: 'subscribedTicketEvents',
            selectedLotteryDraws: 'selectedLotteryDraws',
            selectedLottery: 'selectedLottery',
            allLotteries: 'allLotteries',
            sportState: 'sportState',
            lastSelectedTicketOnline: 'lastSelectedTicketOnline',
            canPlaceOnlineTicket: 'canPlaceOnlineTicket',
            playerdata: 'playerdata',
            betslipItems: 'betslipItems',
            betslipType: 'betslipType',
            betslipLoading: 'betslipLoading',
            betslipItemsCount: 'betslipItemsCount',
        }),
        showHelp()
        {
            return this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.showHelp;
        },
        deviceUserAgent()
        {
            if (window
            && window.navigator
            && window.navigator.userAgent)
            {
                return window.navigator.userAgent;
            }

            return null;
        },
        formatDisplayedBetAmount()
        {
            const me = this;

            let tempCalcDisplayedBetAmount = me.calcDisplayedBetAmount;

            const { payinConfig } = this.betslip;

            if (payinConfig
            && payinConfig.max
            && parseFloat(tempCalcDisplayedBetAmount) > parseFloat(payinConfig.max))
            {
                tempCalcDisplayedBetAmount = payinConfig.max.toString();
            }

            if (!me.betAmountInputFocused)
            {
                if (tempCalcDisplayedBetAmount !== '')
                {
                    // eslint-disable-next-line
                    const displayDecimalsCount = me.globals.publicConfig.localeSetup.defaultBetslipDecimalsCount || me.defaultBetslipDecimalsCount;
                    const decimalCount = me.countDecimals(tempCalcDisplayedBetAmount);

                    let addZeros = '';
                    for (let i = 0; i < displayDecimalsCount - decimalCount; i += 1)
                    {
                        addZeros += '0';
                    }
                    if (decimalCount === 0)
                    {
                        tempCalcDisplayedBetAmount = `${tempCalcDisplayedBetAmount}.${addZeros}`;
                        me.previousFormattedBetAmount = tempCalcDisplayedBetAmount;
                        return tempCalcDisplayedBetAmount.replace(/[^\d.,]/g, '');
                    }
                    tempCalcDisplayedBetAmount = `${tempCalcDisplayedBetAmount}${addZeros}`;
                    return tempCalcDisplayedBetAmount.replace(/[^\d.,]/g, '');
                }
                return me.previousFormattedBetAmount.replace(/[^\d.,]/g, '');
            }
            me.calcDisplayedBetAmount = tempCalcDisplayedBetAmount;
            return me.calcDisplayedBetAmount.replace(/[^\d.,]/g, '');
        },
        showSimple()
        {
            const me = this;
            if (me.$route.name !== 'lotto' || me.betslipType === 'sport' || me.betslipType === 'vhorse')
            {
                return true;
            }
            return false;
        },
        showSystem()
        {
            const me = this;
            if (me.$route.name === 'horses' || me.betslipType === 'vhorse')
            {
                return false;
            }
            return true;
        },
        showBalance()
        {
            const me = this;

            if (me.globals.publicConfig.asCasinoGame && me.playerdata.money)
            {
                return true;
            }

            return false;
        },
        calculateEurConversion()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.hrkEurConversion
                && this.globals.publicConfig.hrkEurConversion.enabled;
        },
        showLottoResultsButton()
        {
            const me = this;

            if (me.globals
            && me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website
            && me.globals.publicConfig.website.extraButtonOptions
            && me.globals.publicConfig.website.extraButtonOptions.displayResultsButtonAboveBetslip)
            {
                return true;
            }

            return false;
        },
        hasLiveEvents()
        {
            const me = this;

            if (me.globals
            && me.globals.publicConfig
            && me.globals.publicConfig.localeSetup
            && me.globals.publicConfig.localeSetup.enableLiveEventsOnTemplateTicket)
            {
                return false;
            }

            if (me.betslipType !== 'sport')
            {
                return false;
            }

            for (const item of me.betslip.items)
            {
                if (item.type === 'sport')
                {
                    if (moment.utc().valueOf() > moment.utc(item.eventDate).valueOf())
                    {
                        return true;
                    }
                }
            }

            return false;
        },
        ticketItems()
        {
            const me = this;

            const itemsOrderedIndexes = [];
            const items = [];
            let sortKey = 'originalIndex';
            let sortKeyType = 'number';
            let sortData = null;
            let isMeta = false;

            // TODO betslip integration items reordering
            if (me.betslipItems.length
            && this.betslipType)
            {
                if (me.betslipType != null
                && me.globals.publicConfig.website !== undefined
                && me.globals.publicConfig.website !== undefined
                && me.globals.publicConfig.website.ticketItemsOrderingPresets !== undefined
                && me.globals.publicConfig.website.ticketItemsOrderingPresets[this.betslipType] !== undefined)
                {
                    sortData = me.globals.publicConfig.website.ticketItemsOrderingPresets[me.betslipType];
                }

                const [firstItem] = me.betslip.items;

                if (sortData != null
                && sortData.field)
                {
                    if (sortData.meta)
                    {
                        if (firstItem.meta != null
                        && firstItem.meta[sortData.field] != null)
                        {
                            sortKey = sortData.field;
                            isMeta = true;
                            sortKeyType = sortData.type;
                        }
                    }
                    else if (firstItem[sortData.field] != null)
                    {
                        sortKey = sortData.field;
                        sortKeyType = sortData.type;
                    }
                }

                for (let i = 0; i < me.betslipItems.length; i += 1)
                {
                    const item = me.betslipItems[i];

                    item.originalIndex = i;
                    item.timestamp = moment(item.eventDate).valueOf();

                    items.push(item);
                }

                if (items.length > 1)
                {
                    items.stableSort((a, b) =>
                    {
                        let aVal;
                        let bVal;

                        if (isMeta)
                        {
                            aVal = a.meta[sortKey];
                            bVal = b.meta[sortKey];
                        }
                        else
                        {
                            aVal = a[sortKey];
                            bVal = b[sortKey];
                        }

                        if (sortKeyType === 'datetime')
                        {
                            aVal = moment(aVal).valueOf();
                            bVal = moment(bVal).valueOf();
                        }
                        else if (sortKeyType === 'text')
                        {
                            aVal = aVal.toString().toLowerCase().trim();
                            bVal = bVal.toString().toLowerCase().trim();
                        }

                        if (aVal < bVal)
                        {
                            return -1;
                        }

                        if (aVal > bVal)
                        {
                            return 1;
                        }

                        return 0;
                    });
                }

                for (let j = 0; j < items.length; j += 1)
                {
                    itemsOrderedIndexes.push(items[j].originalIndex);
                }
            }

            me.itemsSortOrder = itemsOrderedIndexes;

            return items;
        },
        ticketIsLoading()
        {
            const me = this;

            if (me.betslipLoading
            || me.betslip.betslipLoading
            || me.betslip.betslipSubmitting)
            {
                return true;
            }

            return false;
        },
        /* ticketEventStatusError()
        {
            const me = this;

            if (me.ticketIsLoading)
            {
                return false;
            }

            let error = false;

            if (me.ticketType === 'sport')
            {
                for (let i = 0; i < me.betslip.items.length; i += 1)
                {
                    if (me.betslip.items[i].status !== 'active')
                    {
                        error = true;
                        break;
                    }
                }
            }

            const ticketEventStatusErrorId = 'ticket_events_status_inactive';

            if (error)
            {
                me.betslip.showTicketError(
                    {
                        text:
                        {
                            text: 'TICKETHASEVENTSTHATARENOTINACTIVESTATUS',
                        },
                        button1:
                        {
                            text:
                            {
                                text: 'REMOVEINACTIVEEVENTS',
                            },
                            callback()
                            {
                                me.betslip.removeInactiveEvents();
                            },
                        },
                        id: ticketEventStatusErrorId,
                    },
                );
            }
            else
            {
                me.betslip.hideBetslipError(
                    {
                        id: ticketEventStatusErrorId,
                    },
                );

                if (me.ticketType === 'lotto'
                && (me.allTicketErrors.length
                || me.betslip.errors.length))
                {
                    error = true;
                }
            }

            return error;
        }, */
        isSportTicket()
        {
            const me = this;
            if (me.betslipType !== 'sport')
            {
                return false;
            }

            for (const item of me.betslip.items)
            {
                if (item.type !== 'sport'
                && item.type !== 'outrights')
                {
                    return false;
                }
            }

            return true;
        },
        selectedNumbers()
        {
            const me = this;
            if (me.betslipType !== 'lotto')
            {
                return '';
            }

            let nums = [];

            for (const item of me.betslip.items)
            {
                if (item.type === 'lotto')
                {
                    nums.push(item.meta.selectedBall);
                }
                else
                {
                    nums = [];
                    break;
                }
            }

            if (nums.length)
            {
                nums.sort((a, b) => a - b);

                return nums.join(',');
            }

            return '';
        },
        predefinedPayinValues()
        {
            let predefinedValues = [
                1,
                2,
                5,
            ];

            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.predefinedBetslipPayinValues)
            {
                predefinedValues = this.globals.publicConfig.website.predefinedBetslipPayinValues;
            }

            return predefinedValues;
        },
    },
};
</script>
